import { render, staticRenderFns } from "./ConfigurazioneMedicoEditPage.vue?vue&type=template&id=8a0c92a8"
import script from "./ConfigurazioneMedicoEditPage.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneMedicoEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports